import { useState } from "react";
import ProductDetail from "../../components/ProductDetail/ProductDetail";
import NewBornInfo from "../../components/ProductDetail/NewBornInfo";
import DanInfo from "../../components/ProductDetail/DanInfo";
import QuanInfo from "../../components/ProductDetail/QuanInfo";
import PRODUCTS from "../products/productsList";
import { certificates } from "../../components/Cer/cerList";
import { useParams } from "react-router-dom";
import "./DetailPage.css";

export default function DetailPage() {
  const [open, setOpen] = useState(false);
  const params = useParams();
  const productId = params.productId;
  const productInfo = PRODUCTS.find((p) => p.id === +productId);

  const category = productInfo?.cat;

  let ShowInfo;
  if (category === "Newborn") {
    ShowInfo = NewBornInfo;
  } else if (category === "Tã Dán") {
    ShowInfo = DanInfo;
  } else if (category === "Tã Quần") {
    ShowInfo = QuanInfo;
  }

  const showCertificate = () => {
    setOpen(true);
  };

  return (
    <div>
      <ProductDetail productInfo={productInfo} />
      {ShowInfo && <ShowInfo onOpen={showCertificate} />}

      {/* modal certificates */}
      {open && (
        <div className="rumi-modal" onClick={() => setOpen(false)}>
          <div className="rumi-modal-content" onClick={() => setOpen(false)}>
            <span
              className="rumi-close"
              type="button"
              onClick={(e) => {
                setOpen(false);
              }} // 👈 thêm
              aria-label="Đóng"
            >
              &times;
            </span>
            {certificates.map((item, index) => (
              <img
                key={index}
                className="rumi-modal-image"
                src={item.img}
                alt={`img-${index}`}
                style={{ width: "100%", marginBottom: "10px" }}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
